type ConfirmOptions = {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
};

/**
 * Cross‑platform confirm dialog (web implementation).
 */
export function universalConfirm({ title, message }: ConfirmOptions): Promise<boolean> {
  const text = title ? `${title}\n\n${message}` : message;
  const confirmed = window.confirm(text);
  return Promise.resolve(confirmed);
}
